const BLOCK_SELECTOR = '.wp-block-cvip-api-block';
const PAGINATION_LINK_SELECTOR = '.cvip-api-pagination a[href]';

const parseHTML = ( html ) => new DOMParser().parseFromString( html, 'text/html' );

const getInstanceId = ( block ) => block.getAttribute( 'data-cvip-instance' );

const replaceBlockByInstance = ( instanceId, html ) => {
	const parsed = parseHTML( html );
	const nextBlock = parsed.querySelector(
		`${ BLOCK_SELECTOR }[data-cvip-instance="${ instanceId }"]`
	);

	if ( ! nextBlock ) {
		return false;
	}

	const currentBlock = document.querySelector(
		`${ BLOCK_SELECTOR }[data-cvip-instance="${ instanceId }"]`
	);

	if ( ! currentBlock ) {
		return false;
	}

	currentBlock.innerHTML = nextBlock.innerHTML;
	return true;
};

const initAjaxPagination = () => {
	const blocks = document.querySelectorAll( BLOCK_SELECTOR );

	blocks.forEach( ( block ) => {
		block.addEventListener( 'click', async ( event ) => {
			const link = event.target.closest( PAGINATION_LINK_SELECTOR );
			if ( ! link ) {
				return;
			}

			event.preventDefault();
			const instanceId = getInstanceId( block );
			if ( ! instanceId ) {
				window.location.href = link.href;
				return;
			}

			try {
				block.classList.add( 'is-loading' );
				block.setAttribute( 'aria-busy', 'true' );
				const response = await fetch( link.href, {
					credentials: 'same-origin',
				} );

				if ( ! response.ok ) {
					throw new Error( `HTTP ${ response.status }` );
				}

				const html = await response.text();
				const wasReplaced = replaceBlockByInstance( instanceId, html );

				if ( ! wasReplaced ) {
					window.location.href = link.href;
				}
			} catch ( error ) {
				// Fallback to normal navigation if AJAX fails.
				window.location.href = link.href;
			} finally {
				block.classList.remove( 'is-loading' );
				block.removeAttribute( 'aria-busy' );
			}
		} );
	} );
};

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initAjaxPagination );
} else {
	initAjaxPagination();
}
